<template>
  <footer class="footer">
    <div class="content container">
      <div class="columns">
        <div class="column">
          <img
            src="@/assets/keep-logo-inverted.png"
            class="keep-logo"
            alt="Keep"
          />
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <h3>About</h3>
          <p>
            KEEP is part of Trace4Value and aims to develop a traceability solution
            for electronics.
          </p>
          <img
            src="@/assets/logos/Trace_4_value.png"
            class="circla-logo"
            alt="Trace 4 value"
          />
        </div>
        <div class="column is-1"></div>
        <div class="column">
          <h3>Get in touch</h3>
          <p>Want to know more? Talk to our Project Manager Sophie!</p>
          <p>
            Sophie Charpentier
            <span class="email">sophie.charpentier@chalmersindustriteknik.se</span>
          </p>
        </div>
        <div class="column is-1"></div>
        <div class="column cta">
          <Button
            @click.native="isOnboardingModalActive = true"
            text="Try Prototype"
            icon="!forward"
            type="is-secondary"
          />
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import Button from "./Button.vue";
import { sync } from "vuex-pathify";

export default {
  name: "Footer",
  components: { Button },
  computed: {
    isOnboardingModalActive: sync("isOnboardingModalActive"),
  },
  props: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "@/scss/global.scss";

.footer {
  color: #fff;
  h3 {
    font-size: inherit;
    color: #fff;
    font-weight: 400;
    text-transform: uppercase;
    margin-bottom: 2rem;
  }
  .cta {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
  }
  p {
    color: #6A7881;
  }
  .email {
    font-size: 14px;
  }
}
.vinnova-logo {
  width: 140px;
}
.keep-logo {
  max-height: 1.3rem;
}
</style>
